import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const studioBase: Collection = {
  id: 'sp-studio-base',
  brandId: 'sp',
  brandName: 'S|P Collection',
  icon: 'sp-collection.png',
  title: 'Studio Base',
  subTitle: 'Tijdloos',
  banner: 'studio-base/studio-base-banner.jpg',
  items: [
    {
      id: 'sp-studio-base-1',
      collectionImages: [
        {
          image: 'studio-base/Studio Base_5.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'studio-base/Studio Base_4.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-studio-base-1',
      collectionImages: [
        {
          image: 'studio-base/Studio Base_2.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'studio-base/Studio Base_3.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '5cb4c7f2-e04f-4114-a5dc-508df38a8349',
    '00b0a0b0-2b2e-4343-96b4-9f4f2df159e3',
    '42e90a66-5288-4a3b-880f-94c82eac0b1d',
    '6c1b3cdf-3cc6-400a-94e8-84e8df99c18e',
    '4afc6009-9798-426a-af86-a39762994d26',
    'c67cd20b-5556-41c6-8ce6-b999fb8e7a2d',
    'ff5636d4-7afe-4111-8707-16d203099076',
    '8744bd1c-576d-45f1-b982-045edc647a5c',
    '1c57fe5e-bea4-45e2-b51b-edfe0fc50951',
    '5a590090-ab53-4252-8d47-58e07419d46f',
    '1cabc8a1-7c22-41f7-b7e0-4146159a5808',
    'ceb3b185-33cc-4fe7-b51b-32d01e031926',
    '0b294f94-759f-461f-a257-6a3ddabc8f05'
  ]
};
